export default __webpack_public_path__ + "static/media/copy.7815926c.svg";